import { Progress as ChakraProgress, HStack } from "@chakra-ui/react";
import * as React from "react";

export interface ProgressBarProps extends ChakraProgress.RootProps {
  label?: React.ReactNode;
  value: number;
  rootRef?: React.Ref<HTMLDivElement>;
}

export const ProgressBar = React.forwardRef<HTMLDivElement, ProgressBarProps>(
  function ProgressBar(props, ref) {
    const { label = "Progress", value, rootRef, ...rest } = props;

    return (
      <ChakraProgress.Root ref={ref} value={value} {...rest}>
        <HStack gap="5" maxW="sm" w="full">
          <ChakraProgress.Track flex="1">
            <ChakraProgress.Range />
          </ChakraProgress.Track>
          <ChakraProgress.ValueText>{value}%</ChakraProgress.ValueText>
          <ChakraProgress.Label>{label}</ChakraProgress.Label>
        </HStack>
      </ChakraProgress.Root>
    );
  }
);
